import { lazy, StrictMode, Suspense } from 'react'
import ReactDOM from 'react-dom/client'

import { App } from '@/App'
import QueryProvider from '@/components/providers/query-provider.tsx'
import { Toaster } from '@/components/ui/sonner'
import installHttpInterceptors from '@/lib/axios-interceptors'

import AuthProvider from './features/authentication/components/auth-provider.tsx'
import reportWebVitals from './reportWebVitals.ts'
import './styles.css'

const ReactQueryDevtools
  = import.meta.env.DEV
    ? lazy(async () => ({
      default: (await import('@tanstack/react-query-devtools')).ReactQueryDevtools,
    }))
    : null

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  // Install HTTP interceptors and idle/session manager once at startup
  installHttpInterceptors()
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
        {ReactQueryDevtools
          ? (
            <Suspense fallback={null}>
              <ReactQueryDevtools initialIsOpen={false} />
            </Suspense>
          )
          : null}
      </QueryProvider>
      <Toaster richColors position="top-right" />
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example, reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
